import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'
import ApiConfig from '../communicate/ApiConfig'

export default class HomeRequest extends BaseModelRequest {

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();
    return headers;
  }

  loadHomeContent () {
    const url = "home/new";
    return this.get(url)
  }


  loadHomeV2 () {
    const url = "home";
    return this.get(url, '', ApiConfig.v2)
  }
}



// WEBPACK FOOTER //
// ./src/request/HomeRequest.js